angular.module("vgresiduos").factory("calculusService", [
	"$http",
	"$q",
	function ($http, $q) {
		"use strict";

		var calculateDtoHashDict = {};
		function _internalCalculateResidueQuantityConverted(dto) {
			var deferred = $q.defer();

			var dtoHash = objectHash(dto);
			if (calculateDtoHashDict[dtoHash]) {
				deferred.resolve(calculateDtoHashDict[dtoHash]);
				return deferred.promise;
			}

			var req = {
				method: "post",
				data: dto,
				url:
					Vgr.constants.newHostUrl +
					Vgr.resources.apiV1.quantitiesConversions.replace("[RESIDUE_CODE]", dto.ResidueCode)
			};

			var promise = $http(req);
			promise.then(function (response) {
				calculateDtoHashDict[dtoHash] = response;
			});

			return promise;
		}

		function _getResponseConvertedQuantity(quantity) {
			return {
				data: {
					ImpossibleToConvert: false,
					Quantity: quantity
				}
			};
		}

		function _calculateConvertedQuantitySameGroup(originalQuantity, originalConversionFactor, desiredConversionFactor) {
			var deferred = $q.defer();

			var convertedQuantity = (originalQuantity * originalConversionFactor) / desiredConversionFactor;
			var convertedQuantityRounded = Vgr.util.round(convertedQuantity, 8);

			var response = _getResponseConvertedQuantity(convertedQuantityRounded);

			deferred.resolve(response);
			return deferred.promise;
		}

		var _calculateResidueQuantityConverted = function (
			originalQuantity,
			originalMeasureUnit,
			desiredMeasureUnit,
			residueCode,
			referenceDate
		) {
			if (originalMeasureUnit.Group === desiredMeasureUnit.Group) {
				var response = _calculateConvertedQuantitySameGroup(
					originalQuantity,
					originalMeasureUnit.ConversionFactor,
					desiredMeasureUnit.ConversionFactor
				);

				return response;
			}

			if (!originalQuantity) return $q.resolve(_getResponseConvertedQuantity(0));

			return _internalCalculateResidueQuantityConverted({
				Quantity: originalQuantity,
				UnitId: originalMeasureUnit.Id,
				FinalUnitId: desiredMeasureUnit.Id,
				ResidueCode: residueCode,
				ReferenceDate: referenceDate
			});
		};

		return {
			calculateResidueQuantityConverted: _calculateResidueQuantityConverted
		};
	}
]);
